import { useState, useCallback } from 'react';
import clienteAxios from '../config/axios';

export const useInvestmentSale = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [saleResult, setSaleResult] = useState(null);
  const [saleData, setSaleData] = useState({
    amount_percentage: '',
    date_type: '',
    date_value: '',
  });
  
  const updateSaleData = useCallback((field, value) => {
    setSaleData(prev => ({ ...prev, [field]: value }));
  }, []);
  
  const calculateSaleAmount = useCallback((investment, percentage) => {
    const amount = parseFloat(investment?.investment_amount) || 0;
    const returns = parseFloat(investment?.rendimiento) || 0;
    const percentageValue = parseFloat(percentage) || 0;
    return (percentageValue * (amount + returns)) / 100;
  }, []);
  
  const submitSale = useCallback(async (salePayload) => {
    setIsSubmitting(true);
    setSaleResult(null);
    
    try {
      const response = await clienteAxios.post('/api/client/offers/create', salePayload);
      setSaleResult({ success: true, message: response.data.message });
      return true;
    } catch (error) {
      const message = error.response?.data?.message || 'Error al procesar la venta';
      setSaleResult({ success: false, message });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);
  
  const clearSaleResult = useCallback(() => {
    setSaleResult(null);
  }, []);
  
  return {
    saleData,
    updateSaleData,
    submitSale,
    isSubmitting,
    calculateSaleAmount,
    saleResult,
    clearSaleResult,
  };
};